import type { ComponentProps } from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@ifixit/ui/lib/utils';

export function Tabs({
   className,
   scrollFade = true,
   ...props
}: ComponentProps<typeof TabsPrimitive.Root> & {
   /**
    * The tab strip scrolls horizontally with faded edges. Off, the
    * `gradient-overflow` CSS (root gutters, list padding, scroll clipping)
    * goes inert, letting content like DirtyDot overhang the triggers.
    */
   scrollFade?: boolean;
}) {
   return (
      <TabsPrimitive.Root
         data-slot="tabs"
         className={cn(scrollFade && 'gradient-overflow', className)}
         {...props}
      />
   );
}

export function TabsList({ className, ...props }: ComponentProps<typeof TabsPrimitive.List>) {
   return (
      <TabsPrimitive.List
         data-slot="tabs-list"
         className={cn(
            'gradient-overflow-inner inline-flex items-center gap-2 overflow-x-auto pb-2',
            className
         )}
         {...props}
      />
   );
}

export function TabsTrigger({ className, ...props }: ComponentProps<typeof TabsPrimitive.Trigger>) {
   return (
      <TabsPrimitive.Trigger
         data-slot="tabs-trigger"
         className={cn(
            "inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-2 py-1 text-sm font-medium text-gray-900 transition-colors hover:text-brand-500 active:bg-gray-200 focus-visible:outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-gray-200 data-[state=active]:text-current [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
            className
         )}
         {...props}
      />
   );
}

export function TabsContent({ className, ...props }: ComponentProps<typeof TabsPrimitive.Content>) {
   return (
      <TabsPrimitive.Content
         data-slot="tabs-content"
         className={cn(
            'mt-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            className
         )}
         {...props}
      />
   );
}
